import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser, forgotPassword, resetPassword } from "../services/authService"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser)); // 👈 así lo recuperás
    }
  }, []);

  const login = async (cuit, password) => {
    try {
      const userData = await loginUser(cuit, password);
      console.log('Contraseña correcta')

      setUser(userData);
      localStorage.setItem("user", JSON.stringify(userData));

      navigate(`/farmacia/${userData.farmacia.cuit}`);
    } catch (err) {
      throw new Error("Correo o contraseña incorrectos");
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/login");
  };

  const sendRecoveryEmail = async (cuit, mail) => {
    try {
      const response = await forgotPassword(cuit, mail);
      return response.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Error al enviar el correo"
      );
    }
  };

  const resetPass = async (token, newPass) => {
    try {
      const response = await resetPassword(token, newPass);
      return response.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Error al enviar el correo"
      );
    }
  }

  return (
<AuthContext.Provider value={{ user, token: user?.token, setUser, login, logout, sendRecoveryEmail, resetPass }}>
{children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
